import * as React from 'react';
import { useClipboardCopy } from '@web-config-app/core-react';
import {
  IconButton,
  IconButtonProps,
} from '../icon-button/icon-button.component';

type CopyButtonProps = Partial<
  Omit<IconButtonProps, 'onClick' | 'icon' | 'to' | 'label'>
> & {
  label: string;
  contents: string;
};

export const CopyButton = ({
  label,
  priority,
  contents,
  disabled,
  hideLabel,
  css,
  size = 'toolbar',
  tooltip,
}: CopyButtonProps) => {
  const { copyContentsToClipboard, isCopied } = useClipboardCopy(contents);

  return (
    <IconButton
      disabled={disabled}
      css={{
        ...(isCopied
          ? { color: '$successIcon', '&:hover': { color: '$successIcon' } }
          : {}),
        ...css,
      }}
      priority={priority}
      quiet
      icon={isCopied ? 'interfaceCheckmark' : 'interfaceCopy'}
      size={size}
      onClick={() => copyContentsToClipboard()}
      hideLabel={hideLabel}
      tooltip={tooltip}
      label={label}
    />
  );
};
